<template>
  <div class="audio-container">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :zIndex="999"
      :title="title"
      :backCallback="bindBack"
    >
      <!-- <template slot="right">
                <div v-if="isApp" class="share iconfont icon-share" @click="bindShare"></div>
            </template> -->
    </AppNavbar>
    <div class="a-content">
      <!--  <FixedAudio class="fixed-audio" :play="play" :info="info" v-show="fixedAudio" @toggle="bindToggleAudio" /> -->
      <div class="a-scroll" @scroll="bindScroll">
        <div class="a-top">
          <div class="t-title">{{ info && info.title }}</div>
          <div class="t-desc">{{ info && info.description }}</div>
          <!-- <van-image class="top-image" :src="getOssImg(info && info.cover || '')"
                        fit="cover" /> -->
          <CourseImage class="top-image" :src="(info && info.cover) || ''" />
          <AudioComponent
            v-if="info"
            ref="controls"
            :player="player"
            @rate="bindSetRate"
            @front="bindFrontTime"
            @back="bindBackTime"
            @toggle="bindToggleAudio"
            @jump="bindJumpTime"
            @changeEnd="bindChangeEnd"
          />
        </div>
        <div class="a-bottom">
          <div class="detail">详情</div>
          <div class="text" v-if="info" v-html="info.audio_details"></div>
          <van-skeleton v-else title :row="3" />
        </div>
      </div>
      <GymSuspensionBtn v-show="fixedAudio">
        <div class="toggle-play">
          <img
            class="toggle-icon"
            :style="{ transform: 'rotate(' + iconRotate + 'deg)' }"
            @click="bindToggleAudio"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e7a6e05d7cb0c20e9f06270044117886.webp"
            alt=""
          />
        </div>
      </GymSuspensionBtn>
    </div>
    <AppLoading v-show="loadingIcon" class="loading"></AppLoading>
    <van-popup v-if="curPlay" v-model="showPop" position="bottom" closeable>
      <div class="rate-control">
        <div class="title">播放速度{{ curPlay.rate | filterRateText }}</div>
        <div class="rate-line">
          <van-slider
            v-model="curPlay.rate"
            @change="setRate"
            step="0.1"
            min="1"
            max="2"
            active-color="transparent"
            inactive-color="transparent"
          />
          <div class="rate-list">
            <div
              class="rate-item"
              v-for="(item, index) in rateList"
              :key="index"
            >
              <div class="rate-text">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>
<script>
import BaseUrl from '@/request/base.js'
import GymSuspensionBtn from '@/components/GymSuspensionBtn'
import CourseImage from './components/course-image.vue'
import { ProxyAliOss } from './components/oss.js'
import AppLoading from '@/components/app/loading/loading.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import AudioComponent from './components/audio.vue'
import Player from './components/player'
import ShareComponent from '@/components/app/share/share.vue'
import { eventObj } from '@/components/app/share/share-method.js'
export default {
  components: {
    AudioComponent,
    GymSuspensionBtn,
    AppNavbar,
    AppLoading,
    CourseImage,
    ShareComponent
  },
  data() {
    return {
      rateList: [
        {
          value: 1,
          name: '1.0X'
        },
        {
          value: 1.5,
          name: '1.5X'
        },
        {
          value: 2,
          name: '2.0X'
        }
      ],
      options: {},
      newOss: null,
      loading: true,
      title: '',
      fixedAudio: false,
      info: null,
      player: null,
      iconRotate: 0,
      stepList: [25, 50, 75, 90],
      curStudy: 0,
      studyData: {
        start: null,
        end: null
      },
      showPop: false,
      isJumpHistory: false,
      isApp: false,
      showShare: false,
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接',
          id: 3,
          copy: true,
          className: 'share-copy-btn'
        }
      ],
      shareOptions: {
        desc: '快来打开看看，加速燃脂、抗炎抗氧的秘密就在这里哦！',
        title: '向你分享了一个营养闹钟计划！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a8865341b353336bfe340f5e9ebf087.png' // 分享的缩略图的url
      },
      qrcodeUrl: location.href
    }
  },
  watch: {
    newOss: {
      deep: true,
      handler() {
        this.dealImageUrl()
        this.getAudioUrl()
      }
    }
  },
  filters: {
    filterRateText(rate) {
      return rate.toFixed(1) + 'X'
    }
  },
  computed: {
    curPlay() {
      return this.player?.playList[this.player.index] || null
    },
    play() {
      if (this.player && this.player.playList) {
        return this.player.playList[this.player.index].play
      } else {
        return false
      }
    },
    loadingIcon() {
      ;(this.player && this.player.playList[this.player.index].loading) ||
        this.loading
    },
    historyPlayTime() {
      return (
        (this.info && (this.info.last_rate < 100 ? this.info.last_rate : 0)) ||
        0
      )
    }
  },
  beforeDestroy() {
    this.player && this.player.destroy()
  },
  created() {
    this.isApp = this.$http._isApp()
    this.newOss = ProxyAliOss
    this.newOss.initOss()
    this.getData()
    this.init()
  },
  mounted() {
    this.updateRoate()
  },
  methods: {
    bindShare() {
      this.showShare = true
    },
    bindCancel() {
      this.showShare = false
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    setRate(rate) {
      this.player.rate(rate)
    },
    bindSetRate() {
      this.showPop = true
    },
    bindFrontTime(time) {
      this.player.bindFrontTime(time)
    },
    bindBackTime(time) {
      this.player.bindBackTime(time)
    },
    bindToggleAudio() {
      let audio = this.player.playList[this.player.index]
      if (!audio.play) {
        this.studyData.start = new Date().getTime()
      }
      if (!this.isJumpHistory && this.historyPlayTime) {
        this.isJumpHistory = true
        this.player.playHistory(this.historyPlayTime)
      } else {
        this.player.toggle()
      }
    },
    bindJumpTime(time) {
      this.player.seek(time)
    },
    updateRoate() {
      requestAnimationFrame(() => {
        if (this.play) {
          if (this.iconRotate >= 360) {
            this.iconRotate = 0
          } else {
            this.iconRotate = this.iconRotate + 2
          }
        }
        this.updateRoate()
      })
    },
    init() {
      window.onPagePaused = () => {
        let audio = this.player.playList[this.player.index]
        let curTime = audio.curTime || 0
        let totalTime = audio.totalTime
        if (curTime > 0) {
          this.postCourseLearned(curTime, totalTime)
        }
        this.player && this.player.destroy()
      }
    },
    getData() {
      let params = {
        id: this.$route.query.id,
        belong_packet: this.$route.query.packageId || ''
      }
      let url = 'member/CourseClass/getCourseDetail'
      if (this.$route.query.accountid) {
        url =
          BaseUrl.adminUrlData[this.$http.curEv()] +
          '/admin/course.Course/getDetails'
        params.key_token = this.$route.query.accountid
        this.$http
          .get(url, params)
          .then((res) => {
            res = res.data
            if (res.code == 200) {
              this.initAudio(res.data)
            } else {
              this.$router.push('/app-login')
              // this.$toast(res.msg);
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$http
          .getApp(url, params)
          .then((res) => {
            res = res.data
            if (res.code == 200) {
              this.initAudio(res.data)
            } else {
              this.$router.push('/app-login')
              // this.$toast(res.msg);
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    initAudio(data) {
      this.info = data
      this.dealImageUrl()
      let url = this.newOss.getOssImg(this.info.audio_url)
      let audio = [{ url: url, onplay: this.onplay, onend: this.onend }]
      this.player = new Player(audio)
    },
    onplay(index) {
      let audio = this.player.playList[index]
      let curTime = audio.curTime
      let totalTime = audio.totalTime
      let cur = Math.floor((curTime / totalTime) * 100)
      for (let i = 0; i < this.stepList.length; i++) {
        if (cur >= this.stepList[i] && this.stepList[i] > this.curStudy) {
          this.curStudy = cur
          this.postCourseLearned(curTime, totalTime)
          return
        }
      }
    },
    onend() {
      let audio = this.player.playList[this.player.index]
      let curTime = audio.curTime
      let totalTime = audio.totalTime
      this.postCourseLearned(curTime, totalTime)
    },
    bindChangeEnd() {
      /*  let audio = this.player.playList[this.player.index];
             let curTime = audio.curTime;
             let totalTime = audio.totalTime;
             let cur = Math.floor(curTime / totalTime * 100);
             if (this.curStudy < cur) {
                 this.postCourseLearned(curTime, totalTime);
             } */
    },
    dealImageUrl() {
      if (this.newOss.ossClient && this.info) {
        const re = /(<img.*?src=")(.*?)(btw_course[^?]*)(.*?)(".*?>)/g
        this.info.audio_details = this.info.audio_details?.replace(
          re,
          (...e) => {
            return e[1] + this.newOss.getOssImg(decodeURIComponent(e[3])) + e[5]
          }
        )
      }
    },
    getAudioUrl() {
      if (this.newOss.ossClient && this.info && this.info.audio_url) {
        let url = this.newOss.getOssImg(this.info.audio_url)
        let audio = [{ url: url, onplay: this.onplay, onend: this.onend }]
        this.player = new Player(audio)
      }
    },
    bindBack() {
      let audio = this.player.playList[this.player.index]
      let curTime = audio.curTime || 0
      let totalTime = audio.totalTime
      console.log(curTime)
      if (curTime > 0) {
        this.postCourseLearned(curTime, totalTime)
      }
      this.player?.destroy()
      this.$http.appBack()
    },
    bindScroll(e) {
      let scrollTop = e.target.scrollTop
      let el = this.$refs.controls.$el
      if (scrollTop > el.offsetTop + el.clientHeight) {
        this.fixedAudio = true
      } else {
        this.fixedAudio = false
      }
      if (scrollTop >= 100) {
        this.title = this.info.title
      } else {
        this.title = ''
      }
    },
    postCourseLearned(curTime, totalTime) {
      this.studyData.end = new Date().getTime()
      let duration = Math.round(
        (this.studyData.end - this.studyData.start) / 1000
      )
      let per = Math.floor((curTime / totalTime) * 100)
      let params = {
        id: this.$route.query.id,
        time: duration,
        rate: per,
        belong: this.$route.query.packageId || ''
      }
      this.$http
        .postApp('member/CourseClass/courseLearned', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.studyData.start = new Date().getTime()
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.audio-container {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .a-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;

    .a-scroll {
      position: relative;
      height: 100%;
      overflow-y: scroll;
    }
  }

  .fixed-audio {
    z-index: 999;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }

  .a-top {
    padding: 12px 20px 30px;
    background: #f9f9f9;

    .t-title {
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 11px;
    }

    .t-desc {
      word-break: break-all;
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
      margin-bottom: 23px;
    }

    .top-image {
      display: block;
      object-fit: cover;
      width: 180px;
      height: 114px;
      overflow: hidden;
      margin: 0 auto;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.18);
      border-radius: 5px;
    }
  }

  .a-bottom {
    padding: 20px 16px;
    background-color: #fff;

    ::v-deep .van-skeleton {
      padding: 0;
    }

    .detail {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 20px;
    }

    .text {
      white-space: pre-wrap;
      word-break: break-all;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 28px;

      ::v-deep img {
        width: 100%;
      }
    }
  }
}

.toggle-play {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .toggle-icon {
    width: 30px;
    height: 30px;
    object-fit: contain;
    transform: rotate(0deg);
    border-radius: 50%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);

    .iconfont {
      color: #333;
      font-weight: bold;
      font-size: 20px;
    }
  }
}

.rate-control {
  padding-bottom: 84px;

  .title {
    margin-top: 16px;
    margin-bottom: 42px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
  }

  .rate-line {
    position: relative;
    z-index: 1;
    width: 275px;
    background-color: #ccc;
    height: 1px;
    margin: 0 auto;

    .rate-list {
      z-index: -1;
      position: absolute;
      width: 100%;
      height: 9px;
      transform: translate(0%, -50%);
      left: 0;
      top: 50%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .rate-item {
        position: relative;
        width: 1px;
        height: 9px;
        background-color: #ccc;

        .rate-text {
          position: absolute;
          left: 50%;
          top: 12px;
          transform: translate(-50%, 0%);
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }
      }
    }

    ::v-deep .van-slider__button {
      width: 12px;
      height: 12px;
      background: #6236ff;
    }
  }
}

@keyframes iconRotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
